<template>
  <ImgLazy
    :image-url="gifteeForBusiness"
    alt-text="giftee for business"
    aspect-ratio="714 / 80"
  />
</template>
<script>
import ImgLazy from '../images/ImgLazy.vue'
import GifteeForBusiness from '../../../../../images/giftee_for_business.png'
export default {
  components: {
    ImgLazy
  },
  data() {
    return {
      gifteeForBusiness: ''
    }
  },
  mounted() {
    this.gifteeForBusiness = GifteeForBusiness
  }
}
</script>
